import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  handleIconDownload,
} from '../../../helper'
import { TREND_BOTTOM_CHART, TREND_TOP_CHART } from '../constant'
import { selectDataViewByTrend } from '../store/slice'
import BottomChart from './BottomChart'
import TopChart from './TopChart'

const Trend = ({ id, check, isDynamicReport, isDownloadComponent }) => {
  const dataByTrend = useSelector(selectDataViewByTrend)

  const isNoData = !dataByTrend?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  const chart = []
  if (!isDynamicReport) {
    chart.push(...[1, 2])
  } else {
    if (TREND_TOP_CHART.some(({ value }) => check.includes(value))) {
      chart.push(1)
    }
    if (TREND_BOTTOM_CHART.some(({ value }) => check.includes(value))) {
      chart.push(2)
    }
  }

  const isH100 = chart.length === 2

  return (
    <div
      style={{
        height: getStyleHeightContainer(
          isDynamicReport || isDownloadComponent,
          isNoData,
          isH100 ? 332 : 332 / 2,
        ),
      }}
      className="flexColumn gap2"
    >
      {chart.includes(1) && (
        <TopChart
          id={id}
          check={check}
          isDynamicReport={isDynamicReport || isDownloadComponent}
        />
      )}
      {chart.includes(2) && (
        <BottomChart
          id={id}
          check={check}
          isDynamicReport={isDynamicReport || isDownloadComponent}
        />
      )}
    </div>
  )
}

export default Trend
